import React, { Component } from 'react';
import { View, Text, ScrollView } from 'react-native';
import { SForm, SHr, SNavigation, SPopup, SText, STheme, SView, Upload } from 'servisofts-component';
import SSocket from 'servisofts-socket';
import Model from '../../../Model';
import Btn from './Btn';
// import Model from '../../../../Model';
// import Btn from './Btn';
// import InputFoto from '../../../../Components/InputFoto';

type Props = {
    key: string,
    editObject?: any,
    onCancel?: Function,
    onSuccess?: Function,
}

export default class PopupCrearAudio extends Component<Props> {

    static open(props: Props) {
        SPopup.open({
            key: "PopupCrearAudio",
            content: <SView style={{

                maxHeight: "100%",
                // maxWidth: "100%",
                width: "100%",
                maxWidth: 500,
                // width: 500,
                // height: 500,
                borderRadius: 8,
                borderColor: STheme.color.card,
                borderWidth: 1,
                backgroundColor: STheme.color.background
            }} withoutFeedback >
                <PopupCrearAudio {...props} onCancel={() => {
                    SPopup.close("PopupCrearAudio")
                    if (props.onCancel) props.onCancel()
                }}
                    onSuccess={(e: any) => {
                        SPopup.close("PopupCrearAudio")
                        if (props.onSuccess) props.onSuccess(e)
                    }}

                />
            </SView>
        })
    }

    async subirFoto(resp: any) {
        if (this.form) {

            const files1 = this.form.getFiles().audio;
            if (Array.isArray(files1)) {
                console.log("files", files1);
                await Upload.sendPromise({ file: files1[0].file }, SSocket.api.root + "upload/audio/" + resp?.data?.key + ".mp3");
            }

            // const files = this.form.getFiles().video;
            // if (Array.isArray(files)) {
            //     console.log("files", files);
            //     await Upload.sendPromise({ file: files[0].file }, SSocket.api.root + "upload/audio/" + resp?.key + ".mp4");
            // }
        }
    }

    form: SForm | undefined = undefined;
    _ref: any = {}
    render() {
        return <SView col={"xs-12"} center padding={16}>
            <SText fontSize={16}>{this.props.editObject ? "Editar" : "Crear"}{" Audio"}</SText>
            <ScrollView>
                <SForm ref={(ref: any) => this.form = ref}
                    row
                    props={{
                        center: true,
                        col: "xs-12"
                    }}
                    inputProps={{
                        customStyle: "calistenia",
                    }}
                    inputs={{
                        "name": { label: "Nombre", placeholder: "Ingresa nombre", defaultValue: this.props.editObject?.name, col: "xs-12" },
                        "audio": {
                            label: "Audio", placeholder: "Ingresa audio", isRequired: true, type: "file", col: "xs-12",

                            defaultValue: this.props.editObject?.key ? SSocket.api.root + "audio/" + this.props.editObject?.key + ".mp3" : ""
                        },


                    }}
                    onSubmit={(data: any) => {
                        SSocket.sendPromise({
                            component: "audio",
                            type: this.props.editObject ? "editar" : "registro",
                            key_usuario: Model.usuario.Action.getKey(),
                            data: {
                                key: this.props.key,
                                key_usuario: Model.usuario.Action.getKey(),
                                ...(this.props.editObject ?? {}),
                                ...data,
                            }
                        }).then(async (e: any) => {

                            await this.subirFoto(e);
                            if (this.props.onSuccess) this.props.onSuccess(e) //SIEMPRE DE ÚLTIMO
                          
                            console.log("response", e);
                        }).catch((e: any) => {
                            console.error("response", e);
                        })
                    }}

                />
            </ScrollView>
            <SHr h={16} />
            <SView row col={"xs-12"}>
                {this.props.onCancel && <>
                    <Btn type='danger' label='CANCELAR' onPress={() => {
                        if (this.props.onCancel) this.props.onCancel()
                    }} />
                    <SView width={8} />
                </>}

                <Btn type='primary' label='GUARDAR' onPress={() => {
                    if (this.form) this.form.submit();
                }} />

            </SView>
        </SView>
    }
}
